<template>
<div class="history_box">
    <div class="photoHistory_box">
        <div class="operation">
            <span class="all unbind"><i></i> <span i18n="history_all">{{$t("SelectAll")}}</span></span>
            <!-- <span style="display:none;" class="open unbind" i18n="history_open">{{$t("open")}}</span> -->
            <!-- <span class="down unbind" i18n="history_down">{{$t("Download")}}</span> -->
            <span class="delete unbind" i18n="history_delete">{{$t("Delete")}}</span>
            <span class="clear unbind" i18n="history_clear">{{$t("Clear")}}</span>
        </div>
        <img class="load" src="../assets/images/load.svg" alt="Load">
        <div class="noHistory">
            <img src="../assets/images/no-history.svg" alt="No History">
            <p i18n="no_history">{{$t("noHistory")}}</p>
        </div>
        <ul class="scroll_box">
        </ul>
    </div>
    <div class="maskTips1">
        <div  style="max-width: 500px;">
            <i class="close" onclick="$('.maskTips1').hide()"></i>
            <img src="../assets/tip.svg" alt="Tip">
            <p class="errorListInfo"></p>
            <div class="errorList" style="text-align: center;">
                <!-- 剩余<span style="color:#2473E8">{{imgArr.length-downloadId}}</span>张未下载， -->
                {{$t('tips.used_up')}}
            </div>
            <span class="btn btn_v1 errorListBtn_v1"  @click="upgrade">{{$t('btn.tips_upgrade')}}</span>
            <span class="btn btn_v2 continue"  style="color:#2473E8" @click="downloadImg">{{$t('btn.continue_download')}}</span>
        </div>
    </div>
</div>
</template>

<script>
import upload from "../assets/js/upload"
import Japp from "@/assets/js/app"
import utils from '@/js/utils.js';
import { upscaleDownload } from '@/api/upscale'
import JSZip from "jszip"
import FileSaver from "file-saver"
export default {
    props:{
        continuedownload:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return {
            iscontinue:false,
            downloadUrl:'',//带水印图片下载
            saveAllImage:[],
        }
    },
    watch:{
        continuedownload(val){
            this.iscontinue=val;
        }
    },
    methods:{
        upgrade(){
            this.$emit("showPricingPop");
            $('.maskTips1').hide();
        },
        //带水印图片下载
        downloadImg(){
            var self = this;
             $(".maskTips1").hide();
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";  // 防止影响页面
            iframe.style.height = 0;  // 防止影响页面
            iframe.src = self.downloadUrl;//"https://www.istorage-cloud.com/"+
            document.body.appendChild(iframe);
            setTimeout(()=>{
                iframe.remove();
            }, 5 * 60 * 1000);
        },
        async downloadFilePhp(taskid,type){
            var self=this;
            var data={
                // e_id:this.murmur,
                taskids:taskid,
            };
            var res = await upscaleDownload(data);
            console.log("downloadFilePhp",res,res.code);
            if(res.code==200 || res.code==50006){
                var fileName = res.data[0].file_name;
                if(type == 'single'){
                    return self.downloadFileXML(res.data[0].processed_image,fileName)
                }else if(type == 'all'){
                    self.saveAllImage.push({imgUrl:process.env.VUE_APP_S3_URL + res.data[0].processed_image,fileName});
                }
            }            
        },
        // 批量下载
        async downloadAllFile() {
        if (this.saveAllImage.length > 0) {
            console.log(this.saveAllImage, "this.saveImgArr");
            const jszip = new JSZip();
            const imgFolder = jszip.folder("history_images"); // 创建文件夹
            
            // 新增：记录每个文件名的出现次数，解决重名覆盖问题
            const fileNameMap = new Map();

            for (var i = 0; i < this.saveAllImage.length; i++) {
            const url = this.saveAllImage[i].imgUrl;
            const originalFileName = this.saveAllImage[i].fileName;
            
            // 新增：生成不重复的唯一文件名
            let uniqueFileName = originalFileName;
            if (fileNameMap.has(originalFileName)) {
                // 拆分文件名和扩展名，添加序号后缀
                const [name, ext] = originalFileName.split('.');
                const count = fileNameMap.get(originalFileName) + 1;
                fileNameMap.set(originalFileName, count);
                uniqueFileName = ext ? `${name}(${count}).${ext}` : `${originalFileName}(${count})`;
            } else {
                fileNameMap.set(originalFileName, 0);
            }

            const response = await fetch(url);
            if (!response.ok) throw new Error(`下载失败: ${url}`);
            const blob = await response.blob();
            // 修改：使用处理后的唯一文件名
            imgFolder.file(uniqueFileName, blob);
            }

            // 生成ZIP并下载
            const zipBlob = await jszip.generateAsync({ type: 'blob' });
            FileSaver.saveAs(zipBlob, "history_images.zip");
            return true;
        }
        },
        downloadFileXML(url,fileName){
            $(".maskTips1").hide();
            console.log("downloadFileXML",url);
            //fileurl文件地址（一般是接口返回） filename文件下载后的名字
            url = process.env.VUE_APP_S3_URL + url;
            utils.loadImage(url, function (img) {
                let resultUrl = window.URL.createObjectURL(utils.convertBase64UrlToBlob(utils.getBase64Image(img)));
                const a = document.createElement('a');
                a.setAttribute('download', fileName);
                a.setAttribute('href',resultUrl);
                a.click();
            })
            return true
        },
    },
    mounted(){
        var self = this;
var source='';
$('.header .history').click(function(e){
    e.stopPropagation();
    $('.photo_toggle_box').hide();
    $('.photo_rights').hide()
    $('.header .login ul').hide()
    $('.photoHistory_box ul').html('').hide();
    $('.photoHistory_box .noHistory').hide();
    $('.photoHistory_box .load').show()
    if(user){
        $('.photoHistory_box').toggleClass('active')
        taskList(Japp.product_id)
    }else{
        $('.maskMember').show()
    }
})
function taskList(id){
    $.post(
        post_url+"/task/list",
        {
            e_id:user.e_id,
            t_id:user.t_id,
            token:user.token,
            product_id:id
        },
        function(data){
            error_fn(data.error);
            switch(data.error){
                case 0:
                    for(var i=0;i<data.tasks.length;i++){
                        var attach=JSON.parse(data.tasks[i].attach);
                        // console.log(attach);
                        try{
                            var operation=`
                                <!--<i class="open" data="${attach.downloadURL}" style="display:none;"></i>-->
                                <i class="delete"></i>
                                <!-- <i class="copy-link"></i> -->
                                <i class="down watermarker-image" download="${attach.downloadURL}"></i>
                                `
                            $('.photoHistory_box ul').append(`
                            <li class="flex_box" task_id="${data.tasks[i].id}" taskid="${attach.usageid}">
                                <i class="check"></i>
                                <div class="img" style="background-image: url(${attach.icon});"></div>
                                <div class="text">
                                    <p class="name">${attach.name}</p>
                                    <p class="time">${getdate(1,attach.expire)} <span class="effective">(${i18nWaterMark.t('history_will')} ${surplusTime(data.tasks[i].ts_create,attach.expire)})</span><span class="expired">(${i18nWaterMark.t('expired')})</span></p>
                                </div>
                                <div class="box">
                                ${operation}
                                </div>
                            </li>
                            `);
                        }catch(e){
                            console.log(e);//${i18nWaterMark.global.t('Expired')}
                        }
                    }
                    if($('.photoHistory_box ul li').length==0){
                        $('.photoHistory_box ul').hide();
                        $('.photoHistory_box .noHistory').show();
                    }else{
                        $('.photoHistory_box .operation .all').removeClass('unbind');
                    }
                    // 过期处理
                    for(var i=0;i<$('.photoHistory_box ul li').length;i++){
                        if($('.photoHistory_box ul li').eq(i).find('.effective span').attr('num')<0){
                            // $('.photoHistory_box ul li').eq(i).find('.open').addClass('unbind').css('opacity',0);
                            // $('.photoHistory_box ul li').eq(i).find('.down').addClass('unbind').css('opacity',0);
                            $('.photoHistory_box ul li').eq(i).find('.down').css('display','none');
                            $('.photoHistory_box ul li').eq(i).find('.effective').hide()
                            $('.photoHistory_box ul li').eq(i).find('.expired').show()
                            $('.photoHistory_box ul li').eq(i).addClass('expired')
                        }
                    }
                    // 禁用删除全部过期
                    if($('.photoHistory_box ul li.expired').length>0){
                        $('.photoHistory_box .operation .clear').removeClass('unbind')
                    }else{
                        $('.photoHistory_box .operation .clear').addClass('unbind')
                    }
                    break;
                case 26201:
                    error(i18n[lang].error_26201);
                    break;
                case 26202:
                    error(i18n[lang].error_26202);
                    break;
                
            }
            $('.photoHistory_box .load').hide();
            $('.photoHistory_box ul').show();
        }
    )
}
$('.photoHistory_box').click(function(e){
    e.stopPropagation();
})
$('.photoHistory_box ul').on('click','li',function(){
    $(this).toggleClass('active')
    // 0没有选中,1有选中,2全部选中
    if(!$('.photoHistory_box ul li.active').length){
        $('.photoHistory_box .operation .all').removeClass('active').removeClass('semi');
    }else if($('.photoHistory_box ul li.active').length==$('.photoHistory_box ul li').length){
        $('.photoHistory_box .operation .all').addClass('active').removeClass('semi');
    }else{
        $('.photoHistory_box .operation .all').addClass('semi').removeClass('active');
    }
    // 禁用上部批量操作
    if($('.photoHistory_box ul li.active').length>0){
        $('.photoHistory_box .operation>span').removeClass('unbind');
    }else{
        $('.photoHistory_box .operation .all').siblings().addClass('unbind');
    }
    // 禁用Open
    if($('.photoHistory_box ul li.active').length!=1){
        // $('.photoHistory_box .operation .open').addClass('unbind')
    }
    if($('.photoHistory_box ul li.active.expired').length==1&&$('.photoHistory_box ul li.active').length==1){
        // $('.photoHistory_box .operation .open').addClass('unbind')
    }
    // 禁用下载
    if($('.photoHistory_box ul li.active.expired').length==$('.photoHistory_box ul li.active').length){
        $('.photoHistory_box .operation .down').addClass('unbind')
    }
    // 禁用删除全部过期
    if($('.photoHistory_box ul li.expired').length>0){
        $('.photoHistory_box .operation .clear').removeClass('unbind')
    }else{
        $('.photoHistory_box .operation .clear').addClass('unbind')
    }
});
$('.photoHistory_box ul').on('click','.box i',function(e){
    e.stopPropagation();
});
// 删除一条历史
$('.photoHistory_box ul').on('click','.delete',function(){
    historyDelete($(this));
});
// 记录下载 去水印
$('.photoHistory_box ul').on('click','.down.watermarker-image',function(event,val){
    // console.log(val)
    source='one';
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).addClass('unbind');
    var that=$(this);
    // upload.getDownload(2,$(this).attr('download').split("||"),function(){
    //     that.removeClass('unbind');
    // })
    downloadFile(that,val);
});
// 单选下载
// 记录下载 去水印
// $('.photoHistory_box ul').on('click','.down.watermarker-image.unbind',function(event,val){
//     source='one';
//     var that=$(this);
//     downloadFile(that,val);
// });
$('.continue').click(function(){
    if(source=="all"){
        $('.photoHistory_box .operation .down').trigger("click",'continuedown');
    }else if(source=="one"){
        $('.down.watermarker-image.unbind').trigger("click",'continuedown');
    }
    
});
// 全选的操作
$('.photoHistory_box .operation .all').click(function(){
    
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).toggleClass('active').removeClass('semi');
    if($(this).attr('class').indexOf('active')>-1){
        $('.photoHistory_box ul li').addClass('active');
    }else{
        $('.photoHistory_box ul li').removeClass('active');
    }
    // 禁用上部批量操作
    if($('.photoHistory_box ul li.active').length>0){
        $('.photoHistory_box .operation>span').removeClass('unbind');
    }else{
        $('.photoHistory_box .operation .all').siblings().addClass('unbind');
    }
    // 禁用Open
    if($('.photoHistory_box ul li.active').length!=1){
        // $('.photoHistory_box .operation .open').addClass('unbind')
    }
    // 禁用删除全部过期
    if($('.photoHistory_box ul li.active').length==$('.photoHistory_box ul li.expired').length){
        $('.photoHistory_box .operation .down').addClass('unbind');
    }
    if($('.photoHistory_box ul li.expired').length>0){
        $('.photoHistory_box .operation .clear').removeClass('unbind')
    }else{
        $('.photoHistory_box .operation .clear').addClass('unbind')
    }
});
// 全选下载
$('.photoHistory_box .operation .down').click(function(event,val){
    source='all';
    $(this).addClass('active');
    var that = $(this)
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    // 如果只选中一张图片
    if($('.photoHistory_box ul li.active').length == 1){
        for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
            if($('.photoHistory_box ul li.active').eq(i).attr('class').indexOf('expired')<0){
                // 批处理打包下载
                downloadFile($('.photoHistory_box ul li.active').eq(i).find('.down'),val,'single');
            }
        }
    }else{
        for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
            if($('.photoHistory_box ul li.active').eq(i).attr('class').indexOf('expired')<0){
                // 批处理打包下载
                downloadFile($('.photoHistory_box ul li.active').eq(i).find('.down'),val,'all');
            }
        }
       var timerIn = setInterval(function(){
            if(self.saveAllImage.length == $('.photoHistory_box ul li.active').length){
                // 
                clearInterval(timerIn);
                var resultPromise = self.downloadAllFile();
                resultPromise.then(function(data){
                    console.log(data);
                    if(data){
                        that.removeClass('active');
                    }
                })
            }
        },500)
    }
});
// 全选删除
$('.photoHistory_box .operation .delete').click(function(){
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $('.photoHistory_box .operation>span').addClass('unbind')
    for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
        historyDelete($('.photoHistory_box ul li.active').eq(i).find('.delete'));
    }
    $('.photoHistory_box .operation>span').removeClass('unbind')
});
// 打开历史记录的图片
$(".photoHistory_box ul").on('click','.open',function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).addClass('unbind');
    var that=$(this);
    upload.getDownload(3,$(this).siblings('.down').attr('download').split("||"),function(){
        that.removeClass('unbind');
    })
});
$('.photoHistory_box .operation .open').click(function(){
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
        $('.photoHistory_box ul li.active').eq(i).find('.open').click();
    }
});
//删除全部过期
$('.photoHistory_box .operation .clear').click(function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $('.photoHistory_box .operation .clear').addClass('unbind')
    for(var i=0;i<$('.photoHistory_box ul li.expired').length;i++){
        historyDelete($('.photoHistory_box ul li.expired').eq(i).find('.delete'));
    }
});
// 时间戳转换
function getdate(type,time) {
    if(type){
        var now=new Date((time-60*60*24*7)*1000)
    }else{
        var now=new Date(time*1000)
    }
    var y=now.getFullYear()
    var m=now.getMonth()+1
    var d=now.getDate()
    if(type==1){
        return (d < 10 ? "0" + d : d) + "/" + (m < 10 ? "0" + m : m) + "/" + y + " " + now.toTimeString().substr(0, 8);
    }else{
        return (d < 10 ? "0" + d : d) + "-" + (m < 10 ? "0" + m : m) + "-" + y
    }
}
// 计算还剩余多长时间过去
function surplusTime(create,expire){
    var date =Date.parse(new Date())
    var time=(expire-date/1000)/(60*60*24)
    if(time>1){
        return '<span num="'+parseInt(time)+'">'+parseInt(time)+' '+`${i18nWaterMark.t('history.days')}`+'</span>'
    }else{
        return '<span num="'+parseInt((expire-date/1000)/(60*24))+'">'+parseInt((expire-date/1000)/(60*24))+' '+`${i18nWaterMark.t('history.hours')}`+'</span>'
    }
};
//下载
function downloadFile(that,val,type="single"){
    var task_id=that.parent().parent().attr('task_id');
    var imageKey=(that.attr('download').split("||"))[0];
    var taskid=that.parent().parent().attr('taskid');
    // 先清空下saveAllImage

    self.saveAllImage=[];
    if(taskid!="undefined"){
        if(type == 'single'){
            self.downloadFilePhp(taskid,type).then((res)=>{
                if(res == true){
                    // 成功后移除unbind
                    that.removeClass('unbind');
                }
            })
        }else{
            self.downloadFilePhp(taskid,type);
        }
    }else{
        downloadFilePy(task_id,imageKey,val);
    }
}
//下载
function downloadFilePy(task_id,imageKey,val){
    var data={
        imageKey:imageKey,
        e_id:user.e_id,
        task_id:task_id,
    };
    data.lToken=JSON.parse(getCookie('user')).token;
    data.t_id=JSON.parse(getCookie('user')).t_id;
    data.e_id=JSON.parse(getCookie('user')).e_id;
    $('.down.watermarker-image').removeClass('unbind');
    $.ajax({
        url: utils.urlPost('image')+'/download',//https://ai-api.aiseesoft.com/v6/sr/,
        type: 'post',
        datatype:'json',
        async:false,
        data: data,
        success: function(res){
            if(res.status==200){
                if(res.window && val!='continuedown'){
                    $(".maskTips1").show();
                    $('.photoHistory_box').removeClass('active');
                    $('.photoHistory_box .operation .all').removeClass('active');
                    self.downloadUrl = res.url;
                }else{
                    // self.isUpgradeTip=false
                    $(".maskTips1").hide();
                    const iframe = document.createElement("iframe");
                    iframe.style.display = "none";  // 防止影响页面
                    iframe.style.height = 0;  // 防止影响页面
                    iframe.src = res.url;//"https://www.istorage-cloud.com/"+
                    document.body.appendChild(iframe);
                    setTimeout(()=>{
                        iframe.remove();
                    }, 5 * 60 * 1000);
                }
            }
        },
        error: function(error){
            console.log(error)
            // self.imgArr[id].state='error'
            // self.postImage(id+1)
        }
    })
            
}
// 删除

function historyDelete(that){
    if(that.attr('class').indexOf('unbind')>-1){
        return false;
    }
    // that.addClass('unbind');
    var task_id=that.parent().parent().attr('task_id')

    // $.post(
    //     post_url+"task/update",//https://account.api.aiseesoft.com/v6/
    //     {
    //         e_id:user.e_id,
    //         t_id:JSON.parse(getCookie('user')).t_id,
    //         token:JSON.parse(getCookie('user')).token,
    //         product_id:Japp.product_id,
    //         task_id:task_id,
    //         client_ip:'127.0.0.1',
    //         finish:1
    //     },
    //     function(data){
    //         error_fn(data.error)
    //         switch(data.error){
    //             case 0:
                    $.post(
                        post_url+"task/delete",
                        {
                            e_id:user.e_id,
                            t_id:JSON.parse(getCookie('user')).t_id,
                            token:JSON.parse(getCookie('user')).token,
                            product_id:Japp.product_id,
                            task_id:task_id,
                        },
                        function(data){
                            that.removeClass('unbind');
                            error_fn(data.error)
                            switch(data.error){
                                case 0:
                                    that.parent().parent().remove();
                                    $('.photoHistory_box ul li').eq(0).click();
                                    $('.photoHistory_box ul li').eq(0).click();
                                    if($('.photoHistory_box ul li').length==0){
                                        $('.photoHistory_box ul').hide();
                                        $('.photoHistory_box .noHistory').show();
                                        $('.photoHistory_box .operation>span').addClass('unbind');
                                    }
                                    break;
                                case 26101:
                                    error(i18n[lang].error_26101);
                                    break;
                                case 26102:
                                    error(i18n[lang].error_26102);
                                    break;
                                case 26103:
                                    error(i18n[lang].error_26103);
                                    break;
                                case 26104:
                                    error(i18n[lang].error_26104);
                                    break;
                                case 26105:
                                    error(i18n[lang].error_26105);
                                    break;
                                case 26106:
                                    error(i18n[lang].error_26106);
                                    break;
                            }
                        }
                    ).fail(function(xhr){
                        overtime(26199);
                    });
                    // break;
                // case 26001:
                //     error(i18n[lang].error_26001);
                //     break;
                // case 26002:
                //     error(i18n[lang].error_26002);
                //     break;
                // case 26003:
                //     error(i18n[lang].error_26003);
                //     break;
                // case 26004:
                //     error(i18n[lang].error_26004);
                //     break;
                // case 26005:
                //     error(i18n[lang].error_26005);
                //     break;
                // case 26006:
                //     error(i18n[lang].error_26006);
                //     break;
                // case 26007:
                //     break;
                // case 26008:
                //     error(i18n[lang].error_26008);
                //     break;
    //         }
    //     }
    // ).fail(function(xhr){
    //     overtime(26099);
    // });
};

    }
}
</script>

<style lang="scss">
.history_box{
    max-width: 735px;
    width: 95%;
    box-shadow: 0px 6px 13px -4px rgba(0, 0, 0, 0.5);
    border-radius: 18px;
    position: absolute;
    top: 70px;
    right: 30px;
    z-index: 99;
    background: #fff;
}
.maskTips1{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 9;
        display: none;
        >div{
            background: #fff;
            box-shadow: 0px 6px 13px -4px rgba(0,0,0,0.5);
            border-radius: 16px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            max-width: 730px;
            width: 100%;
            padding: 30px 40px 50px;
            box-sizing: border-box;
            text-align: center;
            .close{
                width: 20px;
                height: 20px;
                background: url(../assets/close-m.svg) no-repeat center center/cover;
                position: absolute;
                top: 16px;
                right: 16px;
                cursor: pointer;
            }
            >img{
                display: block;
                margin: auto;
            }
            >p{
                font-size: 16px;
                color: #333;
                line-height: 28px;
                margin-top: 26px;
                margin-bottom: 30px;
            }
            .btn{
                display: inline-block;
                border-radius: 6px;
                min-width: 406px;
                cursor: pointer;
            }
            .btn_v1{
                background: $btn_bg;
                color: #fff;
                line-height: 34px;
            }
            .btn_v1:hover{
                background: $btn_bg;
            }
            .btn_v2{
                line-height: 32px;
                border: 1px solid #979797;
                box-sizing: border-box;
                margin-top: 20px;
            }
            .errorList::-webkit-scrollbar{
                width: 4px;
            }
            .errorList::-webkit-scrollbar-thumb{
                background:rgba(0,0,0,.5);
                border-radius: 4px;
            }
            .errorList{
                max-height: 350px;
                overflow: auto;
                text-align: left;
                margin-bottom: 30px;
                // border: 1px solid #F1F8FF;
                >div{
                    width: 100%;
                    height: 70px;
                    border-bottom: 1px solid #F1F8FF;
                    display: flex;
                    align-items: center;
                    >span{
                        width: 50%;
                        display: inline-block;
                        padding-left: 34px;
                        box-sizing: border-box;
                        vertical-align: middle;
                        color: #FE6363;
                        font-weight: normal;
                    }
                    .left{
                        padding-left: 34px;
                        display: flex;
                        align-items: center;
                        width: 50%;
                        box-sizing: border-box;
                        i{
                            width: 88px;
                            height: 52px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        span{
                            font-weight: normal;
                            font-size: 16px;
                            color: #333;
                            margin-left: 6px;
                        }
                    }
                }
                >div:nth-child(1){
                    background: #F1F8FF;
                    span{
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                    }
                }
                >div:last-child{
                    border-bottom: none;
                }
            }
        }
    }
.photoHistory_box{
    // max-width: 735px;
    width: 100%;
    box-shadow: 0px 6px 13px -4px rgba(0, 0, 0, 0.5);
    border-radius: 18px;
    position: absolute;top: 0px; right: 30px;
    z-index: 99;background: #fff;padding-top: 25px;padding-bottom: 26px;display: none;}
.photoHistory_box.active{display: block;}
.photoHistory_box .operation{font-size: 16px;;padding-right: #333;line-height: 20px;padding-left: 30px;}
.photoHistory_box .operation span{margin-right: 18px;display: inline-block;cursor: pointer;}
.photoHistory_box .operation span.unbind{opacity: .5;}
.photoHistory_box .operation span.down.active {width: 16px;height: 16px;background: url(../assets/images/load.svg);background-size: 100% 100%;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;cursor: auto;font-size: 0;vertical-align: middle;}
.photoHistory_box .operation .all{padding-right: 16px;position: relative;}
.photoHistory_box .operation .all::after{clear: both;content: "";width: 1px;height: 14px;background: #B5B5B5;position: absolute;top: 3px;right: 0px;}
.photoHistory_box .operation .all i{width: 14px;height: 14px;background: url(../assets/images/unselect.svg);display: inline-block;margin-right: 6px;vertical-align: -1px;}
.photoHistory_box .operation .all.active i{background: url(../assets/images/select.svg);}
.photoHistory_box .operation .all.semi i{background: url(../assets/images/semi-select.svg);}
.photoHistory_box .operation .clear{opacity: 1;}
.photoHistory_box ul{margin-top: 15px;max-height: 300px;overflow: auto;}
.photoHistory_box ul li{padding: 10px 30px;-webkit-justify-content: flex-start;justify-content: flex-start;-webkit-align-items: center;align-items: center;}
.photoHistory_box ul li.active{display: flex;}
.photoHistory_box ul li:hover,.photoHistory_box ul li.active{background: #F1F8FF;}
.photoHistory_box ul li .check{width: 14px;height: 14px;background: url(../assets/images/unselect.svg);margin-right: 10px;}
.photoHistory_box ul li.active .check{background: url(../assets/images/select.svg);}
.photoHistory_box ul li .img{width: 96px;height: 54px;background-color: #000;background-size: contain;background-position: center center;background-repeat: no-repeat;}
.photoHistory_box ul li .text{margin-left: 10px;}
.photoHistory_box ul li .text .name{font-size: 16px;color: #333;line-height: 20px;}
.photoHistory_box ul li .text .time{font-size: 14px;color: #666;line-height: 20px;margin-top: 6px;}
.photoHistory_box ul li .text .time .expired{display: none;}
.photoHistory_box ul li .box{text-align: right;flex-grow: 1}
.photoHistory_box ul li .box i{display: inline-block;vertical-align: middle;margin-right: 20px;cursor: pointer;}
.photoHistory_box ul li .box .open{width: 11px;height: 14px;background: url(../assets/images/open.svg);}
.photoHistory_box ul li .box .open:hover{background: url(../assets/images/open-h.svg);}
.photoHistory_box ul li .box .delete{
    width: 16px;
    height: 14px;
    background: url(../assets/images/delete.svg);
}
.photoHistory_box ul li .box .delete:hover{background: url(../assets/images/delete-h.svg);}
.photoHistory_box ul li .box .copy-link{width: 14px;height: 14px;background: url(../assets/images/copy-link.svg);}
.photoHistory_box ul li .box .copy-link:hover{background: url(../assets/images/copy-link-h.svg);}
.photoHistory_box ul li .box .down{width: 15px;height: 13px;background: url(../assets/images/down.svg);}
.photoHistory_box ul li .box .down:hover{background: url(../assets/images/down-h.svg);}
.photoHistory_box ul li .box .open.unbind,.photoHistory_box ul li .box .delete.unbind,.photoHistory_box ul li .box .down.unbind{width: 16px;height: 16px;background: url(../assets/images/load.svg);background-size: 100% 100%;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;cursor: auto;}
.photoHistory_box ul li.expired .text .name,.photoHistory_box ul li.expired .text .time{color: #999;}


.photoHistory_box .load{margin: 30px auto 0px;display: block;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;width: 60px;}
.photoHistory_box .noHistory{margin: 30px auto 0px;text-align: center;display: none;}
.photoHistory_box .noHistory img{margin: auto;display: block;}
.photoHistory_box .noHistory p{font-size: 14px;color: #666;line-height: 20px;margin-top: 10px;}
.scroll_box::-webkit-scrollbar {height: 8px;width: 4px;background: #fff;}
.scroll_box::-webkit-scrollbar-thumb{background: #f1f1f1;}
.scroll_box::-webkit-scrollbar-thumb:hover{background:#ddd}
.scroll_box::-webkit-scrollbar-thumb:active{background:#bbb}
@media screen and (max-width:980px){
    .photoHistory_box{
        left: 50%;
        right: unset;
        transform: translateX(-50%);
        top: 70px;
    }
    .history_box{
        width: 100%;
        top: 0px;
        right: 0px;
    }
}
</style>